/* cSpell:disable */
import { Theme } from './types';
import {
	snsJaImage,
	snsJaWhiteImage,
	showImage,
	resolvaJaPngImage,
	resolvaJaSvgImage,
	resolvaJaWhiteImage,
	recebaJaImage,
	recebaJaWhiteImage,
	notificacoesImage,
	logoImage,
	footerLogoImage,
	avanceJaWhiteImage,
	avanceJaDefaultImage,
	checkUpWhiteImage,
	checkUpImage,
	confirmeJaWhiteImage,
	confirmeJaImage,
	headerLogoImage,
	arrowDownIcon,
	arrowUpIcon,
	adicionarIcon,
	avatarIcon,
	avisoIcon,
	btnAvatarIcon,
	btnPesquisaIcon,
	closeMenuIcon,
	icDeleteIcon,
	documentoIcon,
	downloadIcon,
	apagarIcon,
	calendarioIcon,
	downIcon,
	filtroIcon,
	tabelaMostrarIcon,
	tabelaOcultarIcon,
	upIcon,
	enviarIcon,
	erroIcon,
	hamburguerMenuIcon,
	imprimir05xIcon,
	imprimir1xIcon,
	imprimir2xIcon,
	imprimir3xIcon,
	sairIcon,
	salvarIcon,
	setaCarrocelIcon,
	setaTabelaIcon,
	sucessoIcon,
	uploadIcon,
	vermaisIcon,
	showIcon,
	extratosIcon,
	checkupIcon,
	transferenciasIcon,
	pagarFaturaIcon,
	extratosWhiteIcon,
	checkUpWhiteIcon,
	transferenciasWhiteIcon,
	pagarFaturaWhiteIcon,
	snsJaTable,
	resolvaJaTable,
	confirmeJaTable,
	recebaJaTable,
	avanceJaTable,
	finanFarmaTable,
	approveIcon,
	rejectIcon,
	tooltipIcon,
} from '@assets';

const defaultTheme: Theme = {
	color: {
		primary: {
			primary: '#00C189',
			secondary: '#007C58',
		},
		background: {
			white: '#FFFFFF',
			lightess: '#FAFAFA',
		},
		card: {
			green: '#00C189',
			yellow: '#FBAA19',
			red: '#F15B47',
			black: '#000000',
		},
		button: {
			primary: {
				default: '#00C189',
				hover: '#007C58',
				disabled: '#D0D0D0',
				fontColorDefault: '#FFFFFF',
				fontColorDisable: '#FFFFFF',
			},
		},
		text: {
			body: '#000000',
		},
	},
	font: {
		default: {
			white: '#FFFFFF',
			black: '#000000',
		},
	},
	header: {
		height: '96px',
	},
	body: {
		padding: '',
	},
	button: {
		height: {
			big: '170px',
			small: '48px',
		},
		size: {
			fixed: 'width: 100%; max-width: 300px;',
		},
	},
	image: {
		example: {
			file: avanceJaWhiteImage,
			height: '150px',
			width: '100px',
		},
		avanceJaWhite: avanceJaWhiteImage,
		avanceJaDefault: avanceJaDefaultImage,
		checkUpWhite: checkUpWhiteImage,
		checkUp: checkUpImage,
		confirmeJaWhite: confirmeJaWhiteImage,
		confirmeJa: confirmeJaImage,
		headerLogo: headerLogoImage,
		footerLogo: footerLogoImage,
		logo: logoImage,
		notificacoes: notificacoesImage,
		recebaJaWhite: recebaJaWhiteImage,
		recebaJa: recebaJaImage,
		resolvaJaWhite: resolvaJaWhiteImage,
		resolvaJaSvg: resolvaJaSvgImage,
		resolvaJaPng: resolvaJaPngImage,
		show: showImage,
		snsJaWhite: snsJaWhiteImage,
		snsJa: snsJaImage,
		arrowDown: arrowDownIcon,
		arrowUp: arrowUpIcon,
		adicionar: adicionarIcon,
		avatar: avatarIcon,
		aviso: avisoIcon,
		btnAvatar: btnAvatarIcon,
		btnPesquisa: btnPesquisaIcon,
		closeMenu: closeMenuIcon,
		icDelete: icDeleteIcon,
		documento: documentoIcon,
		download: downloadIcon,
		apagar: apagarIcon,
		calendario: calendarioIcon,
		down: downIcon,
		filtro: filtroIcon,
		tabelaMostrar: tabelaMostrarIcon,
		tabelaOcultar: tabelaOcultarIcon,
		up: upIcon,
		enviar: enviarIcon,
		erro: erroIcon,
		hamburguerMenu: hamburguerMenuIcon,
		imprimir05x: imprimir05xIcon,
		imprimir1x: imprimir1xIcon,
		imprimir2x: imprimir2xIcon,
		imprimir3x: imprimir3xIcon,
		sair: sairIcon,
		salvar: salvarIcon,
		setaCarrocel: setaCarrocelIcon,
		setaTabela: setaTabelaIcon,
		sucesso: sucessoIcon,
		upload: uploadIcon,
		vermais: vermaisIcon,
		showIcon: showIcon,
		extratosIcon: extratosIcon,
		checkupIcon: checkupIcon,
		transferenciasIcon: transferenciasIcon,
		pagarFaturaIcon: pagarFaturaIcon,
		extratosWhiteIcon: extratosWhiteIcon,
		checkUpWhiteIcon: checkUpWhiteIcon,
		transferenciasWhiteIcon: transferenciasWhiteIcon,
		pagarFaturaWhiteIcon: pagarFaturaWhiteIcon,
		snsJaTableIcon: snsJaTable,
		resolvaJaTableIcon: resolvaJaTable,
		confirmeJaTableIcon: confirmeJaTable,
		recebaJaTableIcon: recebaJaTable,
		avanceJaTableIcon: avanceJaTable,
		finanFarmaTableIcon: finanFarmaTable,
		approveIcon: approveIcon,
		rejectIcon: rejectIcon,
		tooltipIcon: tooltipIcon,
	},
	input: {
		height: '48px',
	},
};

export default defaultTheme;
